import { ClipLoader } from "react-spinners"

const PaymentLoadingFiller = () => {
    return (
        <div className="payment-loading-filler">
            <div className="head-1">
                Your consultation is confirmed!
            </div>
            <div className="head-2">
                Loading calendar now...
            </div>
            <ClipLoader color={'#ff7728;'} loading size={40} />
            <div className="next-steps-cont">
                <div className="cont-head">
                    Next Steps
                </div>
                <ul>
                    <li>
                        Schedule your consultation.
                    </li>
                    <li>
                        Meet your domain broker.
                    </li>
                    <li>
                        Build your acquisition strategy.
                    </li>
                    <li>
                        Begin!
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default PaymentLoadingFiller;